import { useIntl } from "react-intl";

import { Avatar } from "@/components/Avatar/Avatar";
import type { Airline } from "@/features/flights/types/types";

type Props = {
  airline: Airline;
  size?: "small" | "medium" | "large";
};

export function AirlineAvatar({ airline, size = "medium" }: Props) {
  const intl = useIntl();

  const nameToUse = airline.name || airline.code;

  return (
    <Avatar
      alt={intl.formatMessage(
        {
          defaultMessage: "{airline} logo",
          description: "Accessible alt text for an airline logo image",
        },
        { airline: nameToUse },
      )}
      size={size}
      src={airline.logoUrl}
      fallback={nameToUse.charAt(0)}
    />
  );
}
